export default __webpack_public_path__ + "static/media/Ranjan_Crop.8c6e854f.jpeg";